module.exports = __webpack_public_path__ + "img/image1.2e3a8463.svg";